import { useT } from "../../i18n";

export const StateMessage = ({ error }) => {
  const t = useT();
  return (
    <p data-testid={error ? "vehicles-error" : "vehicles-empty"} className="border-t border-current/10 py-10 text-sm opacity-60">
      {t(error ? "ui.error" : "ui.empty")}
    </p>
  );
};
